
import { formatPriceWithoutCurrency } from "@/app/infrastructures/misc/Utils";
import { defineComponent } from "vue";

export default defineComponent({
  name: "RankingProgress",
  props: {
    progress: {
      type: Number,
      default: 0
    },
    increase: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return {
      ...props,
      formatNumber: formatPriceWithoutCurrency
    };
  }
});
